import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="relative rounded-3xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=African%20community%20celebration%20and%20hope%2C%20diverse%20group%20of%20people%20raising%20hands%20together%20outdoors%2C%20golden%20sunset%20light%2C%20vibrant%20and%20joyful%20atmosphere%2C%20wide%20angle%20shot%2C%20warm%20earth%20tones%2C%20authentic%20African%20landscape%20background&width=1400&height=600&seq=cta001&orientation=landscape"
            alt="Join IKIRU"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1A0A1E]/92 via-[#2D0A35]/75 to-transparent"></div>

          {/* Purple ribbon top accent */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#4B0082] via-[#C084FC] to-[#7B2D8B]"></div>

          <div className="relative z-10 p-12 md:p-20 max-w-2xl">
            <span className="text-xs font-semibold uppercase tracking-[4px] text-[#C084FC] mb-4 block">Take Action Today</span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-white leading-tight mb-6">
              Join the IKIRU <span className="text-[#C084FC]">Journey</span>
            </h2>
            <p className="text-white/75 leading-relaxed mb-10 text-lg">
              We invite you to be part of IKIRU's transformative journey across Africa's most vulnerable communities. Your partnership will help us scale our impact and achieve our ambitious goals for persons living with epilepsy.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/get-involved"
                className="px-8 py-4 rounded-full bg-[#7B2D8B] text-white font-semibold text-base hover:bg-[#6a2578] transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                Donate Now
              </Link>
              <Link
                to="/get-involved"
                className="px-8 py-4 rounded-full border-2 border-purple-300/50 text-white font-semibold text-base hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                Become a Volunteer
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
